import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { languageList } from '../constants/languages';
import { buildUrl, toLangTag } from '../services/language';

// Служебные страницы и страницы только для PRO не индексируем
const NOINDEX_PATHS = [/^\/settings(\/|$)/, /^\/calculators(\/|$)/, /^\/element\/[^/]+\/compare$/];

// canonical и hreflang для текущей страницы: одна страница на всех 66 языках
const SeoLinks = ({ lang }) => {
  const { pathname } = useLocation();
  const path = pathname.replace(/\/+$/, '') || '/';

  if (NOINDEX_PATHS.some(pattern => pattern.test(path))) {
    return (
      <Helmet>
        <meta name='robots' content='noindex' />
      </Helmet>
    );
  }

  const url = buildUrl(lang, path);

  return (
    <Helmet>
      <link rel='canonical' href={url} />
      {languageList.map(({ symbol }) => (
        <link key={symbol} rel='alternate' hrefLang={toLangTag(symbol)} href={buildUrl(symbol, path)} />
      ))}
      <link rel='alternate' hrefLang='x-default' href={buildUrl('en', path)} />
      <meta property='og:url' content={url} />
    </Helmet>
  );
};

export default SeoLinks;
